import { Component, OnInit } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { RegateResult } from 'app/shared/models/Regate/regate';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-regates',
  templateUrl: './regates.component.html',
  styleUrls: ['./regates.component.scss']
})
export class RegatesComponent extends SubscriptionBaseComponent implements OnInit {

  faSearch = faSearch;

  step = 0;
  regates: RegateResult[];

  token: string;
  userID: any;
  userIsLink: boolean;
  loading = true;

  constructor(
    private titleService: TitleService,
    private authentificationService: AuthenticationService,
    private ffvService: FfvapiService,
    private dataService: DataService

  ) {
    super();
  }

  ngOnInit(): void {
    this.titleService.title.next('Mes Régates');
    this.checkIfALicence();
    this.initSub();
    this.getInfos();
    this.getRegates();
  }

  setStep(index: number): void {
    this.step = index;
  }

  nextStep(): void {
    this.step++;
  }

  prevStep(): void {
    this.step--;
  }

  private checkIfALicence(): void {
    this.ffvService.checkIfALicence().subscribe(res => {
      this.dataService.userIsLink.next(true);


    });
  }

  private getInfos(): void {
    this.userID = this.authentificationService.currentUserValue.id;
    this.token = null;
  }

  private getRegates(): void {
    this.ffvService.getRegateByUser().subscribe(res => {
      this.regates = res;
      this.loading = false;
    }, error => {
      this.loading = false
    });
  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.userIsLink.asObservable().subscribe(userIsLink => {
        this.userIsLink = userIsLink;
      })
    );

  }

}
